import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=96fd65cc&"
import script from "./Incidents.vue?vue&type=script&lang=js&"
export * from "./Incidents.vue?vue&type=script&lang=js&"
import style0 from "./Incidents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports